import { currency } from '@ecg-marktplaats/aurora-js-formatters';
import { TPrice } from 'types/TFeeds';

/**
 * Formats price name or monetary value
 * Ported from @ecg-marktplaats/aurora-templates/src/helpers/formatPrice.js
 */
export default (price: TPrice, t: Function, suppressZeroCents: boolean = true, isPricePerMonth?: boolean): string => {
  const { priceCents, priceType } = price;
  const hasMonetaryValue = ['FIXED', 'FREE_BID', 'MIN_BID'].includes(priceType);
  if (hasMonetaryValue) {
    const monetaryValue = currency(priceCents, true, suppressZeroCents);
    return isPricePerMonth
      ? `${t('listing.price.prefix')} ${monetaryValue} ${t('listing.price.suffix')}`
      : monetaryValue;
  } else {
    return t(`priceTypes:prices.${priceType}`);
  }
};
